import { apiPromotionDetailGet } from "#api/Api_promotion"
import { PromotionColaborador } from "#promotions/components/colaborador/PromotionColaborador"
import { ContextPromotionColaboradorProvider } from "#promotions/contexts/ContextPromotionColaborador"
import { Box, Skeleton, Stack } from "@mui/material"
import { Fragment, useEffect, useState } from "react"
import { usePromotionsContext } from "../PromotionContext"
import DialogConfirm from "./dialogConfirm/DialogConfirm"
const usePromotionDetailData = (promotion_id) => {
	const { actualizar } = usePromotionsContext()
	const [details, setDetails] = useState([])
	const [loading, setLoading] = useState(true)
	useEffect(() => {
		const controller = new AbortController()
		setLoading(true)
		const success = (data) => {
			setDetails(data)
			setLoading(false)
		}
		apiPromotionDetailGet({
			success,
			params: { promotion_id },
			signal: controller.signal,
		})
		return () => {
			controller.abort()
		}
	}, [promotion_id, actualizar])
	return { details, loading }
}

export default function PromotionalChanges({ promotion_id, disable }) {
	const { details, loading } = usePromotionDetailData(promotion_id)
	const { openConfirm, setOpenConfirm } = usePromotionsContext()
	if (loading) return <Skeleton variant="rectangular" width={"100%"} height={"12vh"} />

	return (
		<Box>
			<Stack spacing={2}>
				{details.map((detail) => (
					<Fragment key={`fragment_${detail?.id}}`}>
						<ContextPromotionColaboradorProvider
							detail={detail}
							promotionId={promotion_id}
							key={`s_${detail?.id}}`}
						>
							<PromotionColaborador
								key={`colaborador_${detail?.id}}`}
								detail={detail}
								disable={disable}
							/>
						</ContextPromotionColaboradorProvider>
					</Fragment>
				))}
			</Stack>
			<DialogConfirm
				{...{
					open: openConfirm,
					setOpen: setOpenConfirm,
				}}
			/>
		</Box>
	)
}
